// extracted by mini-css-extract-plugin
export var content = "_mu-1";
export var fullScreen = "_mu-0";